import { render, staticRenderFns } from "./consolidateModal.vue?vue&type=template&id=52207f02&"
import script from "./consolidateModal.vue?vue&type=script&lang=js&"
export * from "./consolidateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports